import { getApiUrl, getWebsocketBaseUrl } from "Config";
import {
  signIn as cognitoSignIn,
  signOut as cognitoSignOut,
  fetchAuthSession,
  getCurrentUser,
} from "aws-amplify/auth";
import axios from "axios";

type Nullable<T> = T | null | undefined;

const local = import.meta.env?.VITE__LOCAL_LOGIN === "true";
let localTestUser: Nullable<string>;

export const signIn = (
  username: string,
  password: string,
  localOverride?: boolean,
  localOverrideUrl?: string,
): Promise<any> => {
  if (local || localOverride) {
    const url = localOverrideUrl || getApiUrl();
    /*
    axios instance to avoid using default interceptors
     */
    return axios
      .create()
      .get(`${url}/get_test_user`, {
        params: { email_address: username },
      })
      .then((resp) => {
        window.localStorage.setItem("localUser", JSON.stringify(resp.data));
        localTestUser = resp.data;
      });
  } else {
    return cognitoSignIn({
      username,
      password,
      options: { authFlowType: "USER_PASSWORD_AUTH" },
    });
  }
};

export const currentUser = (): Promise<any> => {
  if (local) {
    return new Promise((resolve, reject) => {
      if (localTestUser) {
        resolve(localTestUser);
      } else {
        const localUser = window.localStorage.getItem("localUser");

        if (localUser) {
          try {
            localTestUser = JSON.parse(localUser);
            resolve(localTestUser);
          } catch {
            reject("Could not parse current user");
          }
        }
        reject("No current user");
      }
    });
  } else {
    return getCurrentUser();
  }
};

export const getAuthHeader = async (): Promise<any> => {
  if (local) {
    return new Promise((resolve, reject) => {
      if (localTestUser) {
        resolve({ "X-Test-User": localTestUser });
      } else {
        reject("No current user");
      }
    });
  } else {
    return {
      Authorization: `Bearer ${await getAccessJWT()}`,
    };
  }
};

export const getWebSocketURL = async (): Promise<string> => {
  return `${getWebsocketBaseUrl()}?authToken=${await getAccessJWT()}`;
};
export const getAccessJWT = async (): Promise<any> => {
  const jwt = (await fetchAuthSession()).tokens?.accessToken?.toString();
  if (!jwt) {
    throw new Error("No current session");
  }
  return jwt;
};

export const signOut = (): Promise<any> => {
  if (local) {
    window.localStorage.removeItem("localUser");

    return new Promise((resolve) => {
      localTestUser = undefined;
      resolve(null);
    });
  } else {
    return cognitoSignOut();
  }
};
